import { AnimatePresence, motion } from "framer-motion";
import React from "react";
import { MdExpandLess, MdExpandMore } from "react-icons/md";
import { defaultTheme } from "../../../styles/themes/defaultTheme";
import RoleItems from "../../Tools/RoleItems.tsx";
import { UserRequestRole } from "./_core/_models.ts";
import { allAccessRoleID } from "../../../Constants.ts";
import { TbChecks } from "react-icons/tb";
import TooltipButton from "../../Tools/TooltipButton.tsx";
import { MdError } from "react-icons/md";
import { useAppContext } from "../../../context/AppContext.tsx";

interface request {
    header: string,
    subHeader: string,
    checkLabel: string,
    ddNote: string,
    textNote: string,
    expand: boolean,
    roleItems: UserRequestRole[],
    updateItems: (item: UserRequestRole[]) => void,
    onExpand: (exp: boolean) => void,
    dimensionCode: string
}

export function DimensionSection({ header, subHeader, checkLabel, ddNote, textNote, expand, onExpand, roleItems, updateItems, dimensionCode }: request) {
    const { dimensions } = useAppContext();
    const headedrString = () => {
        let hString = dimensions.find((d) => d.dimensionCode == dimensionCode)?.dimensionName;
        if (roleItems.length > 0) {
            let rString = "";
            let rLength = roleItems.filter((x) => x.roleID != null && x.roleID > 0).length;
            if (rLength > 0)
                rString += ` ${rLength} role(s)`;
            rLength = roleItems.filter((x) => !x.conditions.isEmpty()).length;
            if (rLength > 0)
                rString += ` ${rLength} conditions(s)`;
            hString = dimensions.find((d) => d.dimensionCode == dimensionCode)?.dimensionName + ": " + rString;
        }
        return hString;
    }
    const isAllowed = () => {
        let yes = false;
        if (roleItems.length > 0 && roleItems.length == roleItems.filter((x) => x.roleID != 0 || x.conditions != "").length)
            yes = true;
        return yes;
    }
    return (
        <div className="card mb-3">
            <div className="card-header" onClick={() => {
                //onExpand(!expand)
            }} style={{ backgroundColor: dimensions.find((d) => d.dimensionCode == dimensionCode)?.bg, color: dimensions.find((d) => d.dimensionCode == dimensionCode)?.color }}>
                <div className="d-flex flex-row align-items-center justify-content-between">
                    <h5 className="mb-0 fs-6">
                        <span className="d-flex flex-row align-items-center gap-1">
                            {/* {
                                isAllowed() ?
                                    <TooltipButton title={"Requred Details filled"}>
                                        <TbChecks color="green" size={24} />
                                    </TooltipButton> :
                                    <TooltipButton title={"Details not filled"}>
                                        <MdError color="red" size={24} />
                                    </TooltipButton>
                            } */}
                            {headedrString()}
                        </span>
                    </h5>
                    {/* {
                        expand ? <MdExpandLess size={24} /> :
                            <MdExpandMore size={24} />
                    } */}
                </div>
            </div>
            <AnimatePresence>
                {expand &&
                    <motion.div className="card-body"
                        key={"details"}
                        initial={{ opacity: 0, y: -10 }}
                        animate={{ opacity: 1, y: 0 }}
                        exit={{ opacity: 0, y: 10 }}
                        transition={{ duration: 0.2 }}>
                        <p className="fw-bold mb-2">{subHeader}</p>
                        <div className="form-check form-switch mb-2 r_man_all">
                            <input
                                type="checkbox"
                                id="productLineAll"
                                checked={roleItems.findIndex((x) => x.roleID == allAccessRoleID[dimensionCode]) > -1}
                                onChange={(c) => {
                                    let tItems = roleItems;
                                    if (c.target.checked) {
                                        let tItem: UserRequestRole = { excluded: false, roleID: allAccessRoleID[dimensionCode], conditions: "", stagingUserID: 0 };
                                        tItems = [tItem];
                                    }
                                    else
                                        tItems = [];
                                    updateItems(tItems);
                                }}
                                className="form-check-input form-switch"
                            />
                            <label className="form-check-label" htmlFor="productLineAll">
                                {checkLabel}
                            </label>
                        </div>
                        {
                            roleItems.findIndex((x) => x.roleID == allAccessRoleID[dimensionCode]) == -1 &&
                            <>
                                <p className="text-muted-theme small">
                                    {ddNote}
                                </p>
                                <div className='w-100 r_man_role' >
                                    <RoleItems showDropdown={true} dimensionCode={dimensionCode}
                                        initItems={(typeof roleItems.filter((x) => x.roleID != 0) != 'undefined') ?
                                            roleItems.filter((x) => x.roleID != 0) : []}
                                        updateItems={(items) => {
                                            let pVals = roleItems;
                                            let txtItems = pVals.filter((x) => x.roleID == 0);
                                            let nRoles = items.map((x) => {
                                                let n: UserRequestRole = { excluded: false, roleID: (x != "") ? parseInt(x) : null, conditions: "", stagingUserID: 0 };
                                                return n;
                                            });
                                            updateItems(txtItems.concat(nRoles));
                                        }} />
                                </div>
                                <p className="text-muted-theme small">
                                    {textNote}
                                </p>
                                <div className='w-100 r_man_cond' >
                                    <RoleItems showDropdown={false} dimensionCode={dimensionCode} initItems={(typeof roleItems.filter((x) => x.roleID == 0).map((x) => x.roleID?.toString()) != 'undefined') ? roleItems.filter((x) => x.roleID == 0) : []}
                                        updateItems={(items) => {
                                            let pVals = roleItems;
                                            let rItems = pVals.filter((x) => x.roleID != 0);
                                            let nRoles = items.map((x) => {
                                                let n: UserRequestRole = { excluded: false, roleID: 0, conditions: x, stagingUserID: 0 };
                                                return n;
                                            });
                                            updateItems(rItems.concat(nRoles));
                                        }} />
                                </div>
                            </>
                        }
                    </motion.div>
                }
            </AnimatePresence>

        </div>
    )
}

export default DimensionSection;